import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import axios from 'axios'
import router from '@/router'

const STORAGE_KEY = 'nelow_auth'

export const useAuthStore = defineStore('auth', () => {
  const stored = sessionStorage.getItem(STORAGE_KEY)
  const credentials = ref(stored)
  const username = ref(stored ? atob(stored).split(':')[0] : null)
  const isAuthenticated = computed(() => !!credentials.value)

  async function login(user, pass) {
    const encoded = btoa(`${user}:${pass}`)
    try {
      await axios.get('/api/overview', {
        headers: { Authorization: `Basic ${encoded}` },
      })
      credentials.value = encoded
      username.value = user
      sessionStorage.setItem(STORAGE_KEY, encoded)
      return true
    } catch {
      return false
    }
  }

  function logout() {
    credentials.value = null
    username.value = null
    // 세션 스토리지 전체 초기화 (auth 토큰뿐 아니라 select_customer_id 등 모든 키)
    try { sessionStorage.clear() } catch { /* noop */ }
    router.push({ name: 'login' })
  }

  return { credentials, username, isAuthenticated, login, logout }
})
